/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

const IdleTimeout = ({ time, onTimeout, children }) => {
  const [timeout, setTimeout] = useState(time);
  const updateExpiredTime = () => {
    localStorage.setItem("_expiredTime", Date.now() + timeout * 1000);
  };

  const tracker = () => {
    window.addEventListener("mousemove", updateExpiredTime);
    window.addEventListener("scroll", updateExpiredTime);
    window.addEventListener("keydown", updateExpiredTime);
  };
  const unbind = () => {
    window.removeEventListener("mousemove", updateExpiredTime);
    window.removeEventListener("scroll", updateExpiredTime);
    window.removeEventListener("keydown", updateExpiredTime);
  };

  const startInterval = () => {
    updateExpiredTime();
    const int = setInterval(() => {
      const expiredTime = parseInt(localStorage.getItem("_expiredTime") || 0, 10);
      if (expiredTime < Date.now()) {
        if (typeof onTimeout === "function") {
          onTimeout();
        }
      }
    }, 1000);
    return int;
  };
  useEffect(() => {
    setTimeout(time);
    const interval = startInterval();
    tracker();
    return () => {
      unbind();
      localStorage.removeItem("_expiredTime");
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setTimeout(time);
  }, [time]);
  return children;
};

export default IdleTimeout;
